/* React hooks */
import { useContext } from "react";
/* Contexts */
import DataContext from "../context/DataProvider";


export default function useData() {
    return useContext(DataContext)
};